@if (tiles) {

<div class="wrap center p-t-10 p-b-10 p-b-8-s">
    <p class="o1"
       *iCms="'subtitle' of component; skipEmpty: true">
    </p>
    <h2 class="h1 m-t-1"
        *iCms="'title' of component">
    </h2>
    <p class="p2 m-t-1 w-5 w-12-s w-12-m"
       *iCms="'description' of component; skipEmpty: true; content: 'html'">
    </p>
</div>
<div [ngClass]="component.background ? component.background : '_calendarBackground'">
    @if (isCalendarExpired) {
    <div class="wrap p-t-10 center col-w"
         [style.padding-bottom.px]="client.isS ? 40 : 120">
        <div class="w-12 ratio-16-9 ratio-4-3-s ratio-4-3-m overflow-hidden">
            <shell></shell>
            <img class="fill"
                 [image]="component.expiredImage">
        </div>
        <p class="m-t-10"
           [sizeClass]="'SM: h2, XL: h1'"
           *iCms="'expiredTitle' of component; content: 'html'">
        </p>
        <p class="p2 m-t-5 m-t-1-s"
           [sizeClass]="'SM: p1, XL: p2'"
           *iCms="'expiredDescription' of component; skipEmpty: true; content: 'html'">
        </p>
        <href [link]="component.expiredLink">
            <span class="button m-t-5 m-t-3-s" *iCms="'expiredButtonText' of component"></span>
        </href>
    </div>
    } @else {
    <div class="wrap p-t-10 p-b-10">
        <div class="_firstRow w-12">
            @for(tile of tiles.slice(0,3); track tile.number) {
            <ng-container *ngTemplateOutlet="tileTpl; context: {tile: tile, haveRatio: tile.number !== 3 }">
            </ng-container>
            }
        </div>
        <div class="_secondRow w-12 m-t-5">
            <div class="_item">
                @for(tile of tiles.slice(3,7); track tile.number) {
                <ng-container *ngTemplateOutlet="tileTpl; context: { tile: tile, haveRatio: true }">
                </ng-container>
                }
            </div>
            <!-- tile 8 -->
            <div class="_item">
                <ng-container *ngTemplateOutlet="tileTpl; context: { tile: tiles[7], haveRatio: false }">
                </ng-container>
            </div>
            <div class="_item">
                @for(tile of tiles.slice(8,12); track tile.number) {
                <ng-container *ngTemplateOutlet="tileTpl; context: { tile: tile, haveRatio: true }">
                </ng-container>
                }
            </div>
        </div>
    </div>
    }
</div>
}
<ng-template #tileTpl
             let-tile="tile"
             let-haveRatio="haveRatio">
    @if(tile) {
    <div class="_tile _overlay overflow-hidden"
         [ngClass]="[getStatusClass(tile.status)]"
         [class.ratio-1-1]="haveRatio"
         (click)="openTile(tile)">
        <shell></shell>
        @if(tile.afterOpenImage && tile.status !== tileStatus.expired && tile.status !== tileStatus.soon) {
        <img class="fill z-1"
             [class.ng-hide]="tile.status !== tileStatus.opened && tile.status !== tileStatus.expiredOpened"
             [image]="tile.afterOpenImage">
        }
        <img class="fill"
             [class.ng-hide]="tile.status === tileStatus.opened && tile.status !== tileStatus.expiredOpened && tile.afterOpenImage"
             [image]="tile.mainImage">

        <div class="_number"
             [ngClass]="tile.numberColorWhite ? 'col-w': 'col-1'">{{tile.number}}</div>
        @if(getStatusLabel(tile.status)) {
        <label class="_label p2"
               [ngClass]="[component.labelBackground || 'bg-col-6', component.labelTextColor || 'col-w']">
            {{getStatusLabel(tile.status)}}
        </label>
        }
        @if(tile.status === tileStatus.available) {
        <label *ifSize="'SM'"
               class="_label p2 bg-col-1 col-w">
            {{'Open Offer' | translate}}
        </label>
        }
    </div>
    }

</ng-template>
